import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Get the environment variable from the window or process object
export const getEnv = (key: string): string | undefined => {
  if (typeof window !== 'undefined' && window.ENV) {
    const windowValue = window.ENV[key as keyof typeof window.ENV];
    if (windowValue) {
      return windowValue;
    }
  }
  if (typeof process !== 'undefined') {
    return import.meta.env[key] || process.env[key];
  }

  return undefined;
};
